import { useHistory, useLocation } from '@atlassian/mpac-ui';
import { useEffect } from 'react';
export function useNlpSearchParam(enableNLPSearchFlag) {
  const history = useHistory();
  const {
    pathname,
    search
  } = useLocation();
  useEffect(() => {
    if (enableNLPSearchFlag) {
      const queryParams = new URLSearchParams(search);
      queryParams.set('nlp', 'true');
      history === null || history === void 0 ? void 0 : history.replace("".concat(pathname, "?").concat(queryParams));
    }
  }, [enableNLPSearchFlag]);
}